import { useState, useEffect } from 'react';
import Style from './customSearch.tailwind.js';
import { Loader, Search, SearchableDropdown } from 'components/lib';

export function CustomSearch(props) {

    const [body, setBody] = useState(null);

    useEffect(() => {
        if (props.data) {
            setBody(props.data);
        }
    }, [props.data]);

    if (props.loading) {
        return (
            <div className={Style.loading}>
                <Loader />
            </div>
        );
    }

    // no data
    if (!body)
        return false

    function search(term) {
        let rowsToShow = [];

        body?.forEach(row => {
            for (let cell in row) {
                if (row[cell]?.toString().toLowerCase().includes(term.toLowerCase())) {
                    if (!rowsToShow.includes(row))
                        rowsToShow.push(row);
                }
            }
        });

        // if (props.searchName && user)
        //     props.setUser(user);

        props.setFilter(rowsToShow);
    }

    return (
        <div className={Style.inputs}>
            {props.search &&
                <Search
                    className={Style.search}
                    callback={search}
                    throttle={props.throttle}
                />}

            {props.searchableDropdownData &&
                props.searchableDropdownData.map((x, i) => {
                    return <SearchableDropdown
                        options={x.options}
                        callback={search}
                        name={x.name}
                        placeholder={x.placeholder}
                        key={i}
                        parentStyle={Style.searchableDropdown}
                        inputStyle={Style.searchableDropdownInput}
                    />
                })
            }
        </div>
    );
}